var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"theme":"dark-lime"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n    To make SanitizerWristbands.com work , we log user data. By using this website, you agree to our "),_c('router-link',{attrs:{"to":"privacy-policy"}},[_vm._v("Privacy Policy")]),_vm._v(" including cookie policy\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eae1982","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieBanner.vue
// module id = null
// module chunks = 